import { takeEvery, put, fork } from "redux-saga/effects";
import * as actions from "../actions/OperatorMainPageActions";
import * as api from "../../api/OperatorMainPage";
import { setBackdrop, resetBackdrop } from "../actions/BackdropActions";
import { showInfoSnackbar, showErrorSnackbar } from "../actions/SnackbarActions";

function* getNotifications(action) {
    try {
        const { data } = yield api.getNotifications(action.payload);
        yield put(actions.setNotificationList(data || undefined));
    } catch (error) {
        yield put(actions.setNotificationList(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getActiveCounts() {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getActiveCounts();
        yield put(actions.setActiveCounts(data || undefined));
    } catch (error) {
        yield put(actions.setActiveCounts(undefined));
        // yield put(showSnackMessage(error, 'error'));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getAutonomousActiveCounts() {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getAutonomousActiveCounts();
        yield put(actions.setAutonomousActiveCounts(data || undefined));
    } catch (error) {
        yield put(actions.setAutonomousActiveCounts(undefined));
        // yield put(showSnackMessage(error, 'error'));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getBarCodeContext(action) {
    try {
        const data = yield api.getBarCodeContext(action.payload);
        const {
            data: { resultObject },
        } = data;
        if (resultObject) {
            yield put(actions.setBarCodeContext(data || undefined));
        } else {
            // yield put(showSnackMessage({ response: data }));
            yield put(showInfoSnackbar({ response: data }));
        }
    } catch (error) {
        yield put(actions.setBarCodeContext(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* watchAll() {
    yield takeEvery(actions.Types.GET_ACTIVE_COUNTS, getActiveCounts);
    yield takeEvery(actions.Types.GET_NOTIFICATIONS, getNotifications);
    yield takeEvery(actions.Types.GET_BARCODE_CONTEXT, getBarCodeContext);
    yield takeEvery(actions.Types.GET_ACTIVE_COUNTS, getAutonomousActiveCounts);
}

const operatorMainPageSaga = [fork(watchAll)];

export default operatorMainPageSaga;
